
import React from 'react';
import { Input } from '@/components/ui/input';

interface DeviceGroupsSearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

const DeviceGroupsSearch: React.FC<DeviceGroupsSearchProps> = ({ searchTerm, onSearchChange }) => {
  return (
    <div className="flex items-center space-x-2">
      <div className="relative flex-1">
        <Input
          placeholder="Search groups..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full"
        />
      </div>
    </div>
  );
};

export default DeviceGroupsSearch;
